import { useState, useRef, KeyboardEvent } from 'react';
import { useConversationStore } from '../../stores/conversationStore';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Send } from 'lucide-react';

export function MessageInput() {
  const { activeConversationId, sendMessage, isSending } = useConversationStore();
  const [input, setInput] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSubmit = () => {
    if (!input.trim() || !activeConversationId || isSending) {
      return;
    }

    sendMessage(activeConversationId, input.trim());
    setInput('');

    // Reset textarea height
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    // Submit on Enter (without Shift)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInput(e.target.value);

    // Auto-resize textarea
    e.target.style.height = 'auto';
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  if (!activeConversationId) {
    return null;
  }

  return (
    <div className="border-t bg-background p-4">
      <div className="flex gap-2 items-end max-w-4xl mx-auto">
        <Textarea
          ref={textareaRef}
          value={input}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="Schreiben Sie eine Nachricht... (Enter zum Senden, Shift+Enter für neue Zeile)"
          disabled={isSending}
          className="min-h-[60px] max-h-[200px] resize-none"
          rows={1}
        />

        <Button
          onClick={handleSubmit}
          disabled={!input.trim() || isSending}
          size="icon"
          className="h-[60px] w-[60px] shrink-0"
        >
          <Send className="h-5 w-5" />
        </Button>
      </div>

      <p className="text-xs text-muted-foreground text-center mt-2">
        KI kann Fehler machen. Überprüfen Sie wichtige Informationen.
      </p>
    </div>
  );
}
